export default __webpack_public_path__ + "images/3Q.9546f2a.png";